<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>实验管理</p>
    </div>
    <div class="panel-content center_content">
      <div id="searchSection">
        <input
          type="text"
          v-model="queryInfo.title"
          placeholder="实验名称"
          class="s-input separate"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.status"
        >
          <option value="">选择状态</option>
          <option
            v-for="(val,key) in $store.state.dict_experiment_state"
            :key="key"
            :value="key"
          >{{val}}</option>
        </select>
        <input
          type="button"
          value="搜索"
          class="s-btn"
          @click="queryInfo.page=1,search()"
        >
      </div>
      <ul
        id="list"
        class="list"
        v-if="tableData.length"
      >
        <li
          v-for="(item,index) in tableData"
          :key="index"
        >
          <div class="pic-wrap">
            <template>
              <span
                class="mark mark0"
                v-if="item.experiment.status==1"
              >填报中</span>
              <span
                class="mark mark1"
                v-if="item.experiment.status==2"
              >待学院审核</span>
              <span
                class="mark mark2"
                v-if="item.experiment.status==3"
              >学院审核未通过</span>
              <span
                class="mark mark1"
                v-if="item.experiment.status==4"
              >待学校审核</span>
              <span
                class="mark mark2"
                v-if="item.experiment.status==5"
              >学校审核未通过</span>
              <span
                class="mark mark1"
                v-if="item.experiment.status==6"
              >待省管理员审核</span>
              <span
                class="mark mark2"
                v-if="item.experiment.status==7"
              >省管理员审核未通过</span>
              <!--              <span-->
              <!--                class="mark mark1"-->
              <!--                v-if="item.experiment.status==8"-->
              <!--              >待系统管理员审核</span>-->
              <!--              <span-->
              <!--                class="mark mark2"-->
              <!--                v-if="item.experiment.status==9"-->
              <!--              >系统管理员未通过</span>-->
              <span
                class="mark mark3"
                v-if="item.experiment.status==8"
              >待发布</span>
              <span
                class="mark mark4"
                v-if="item.experiment.status==9"
              >已发布</span>
            </template>
            <img
              :src="item.experiment.logo"
              :onerror="$store.state.defaultImg"
              alt=""
            >
          </div>
          <div class="desc-wrap">
            <p class="p1">{{item.experiment.title}}</p>
            <p class="p2">
              <span>学院：{{item.experiment.academy_id?item.experiment.academy.title:'--'}}</span>
              <span>负责人：{{item.master_name ? item.master_name : '--'}}</span>
              <span>年份：{{item.experiment.auth_year ? item.experiment.auth_year : '--' }}</span>
              <span>对应专业大类：{{item.experiment.subject.subject_category.title}}</span>
              <span>对应专业：{{item.experiment.subject.title}}</span>
            </p>
            <p class="text-intro">
              <span>实验简介：</span>{{item.experiment.brief}}
            </p>
            <div class="btns-wrap">
              <router-link
                :to="'/www/experiment?id=' + item.experiment.id"
                class="btnOk btn-green"
              >实验预览</router-link>
              <router-link
                :to="'/admin/experiment_maintain?id=' + item.experiment.id"
                class="btnOk btn-yellow"
              >实验管理</router-link>
              <!--              <router-link-->
              <!--                :to="'/admin/experimentTeacher_maintain?id=' + item.experiment.id"-->
              <!--                class="btnOk btn-blue"-->
              <!--              >学生及分组管理</router-link>-->
              <router-link
                :to="'/admin/experimentViewScore?experiment_id=' + item.experiment.id + '&title=' + item.experiment.title"
                class="btnOk btn-blue"
              >查看成绩</router-link>
              <a
                @click="makePdf(item.experiment.id)"
                href="javascript:void(0)"
                class="btnOk btn-orange"
              >电子申报书</a>
            </div>
          </div>
        </li>
      </ul>
      <div
        class="noitems"
        v-else
      >没有数据</div>
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'MyExperiment',
  components: {
    Pagination
  },
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        title: '',
        status: ''
      },
      tableData: [],
      tableDataCount: 0
    }
  },
  // 函数方法
  methods: {
    pageCallback(data) {
      this.queryInfo.page = data
      this.search()
    },
    async search() {
      this.queryInfo.userprofile_id = this.localUser.profile_id
      await this.$http.get('/experimentmember/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    async makePdf (id) {
      await this.$http.post('/exp_print/' + id, {
        id: id
      }).then((data) => {
        if (data.code === 200) {
          window.open('/static/print_file/' + data.data, '_blank')
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    localUser() {
      return this.$store.state.userInfo
    }
  },
  mounted() {
    this.search()
  }
}
</script>

<style scoped lang="less">
.list li {
  overflow: hidden;
  margin-bottom: 20px;
  padding: 20px 0;
  border-bottom: 2px solid #f1f5f5;
  .pic-wrap {
    width: 240px;
    height: 160px;
    float: left;
    position: relative;
    .mark {
      position: absolute;
      left: 0;
      top: 0;
      height: 26px;
      line-height: 26px;
      padding: 0 10px;
      font-size: 12px;
      color: #fff;
      border-bottom-right-radius: 5px;
    }
    .mark0 {
      background: #eb6736;
    }
    .mark1 {
      background: #009999;
    }
    .mark2 {
      background: #fe2323;
    }
    .mark3 {
      background: #ff9000;
    }
    .mark4 {
      background: #73D6CA;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .desc-wrap {
    padding-left: 260px;
    font-size: 14px;
    color: #666;
    .p1 {
      font-size: 18px;
      color: #000;
    }
    .p2 {
      color: #4a5d76;
      padding: 5px 0;
      span {
        color: #666;
        margin-right: 30px;
        line-height: 26px;
      }
    }
    .text-intro {
      height: 52px;
      overflow-y: auto;
      > span {
        color: #000;
      }
    }
    .btns-wrap {
      margin-top: 10px;
      overflow: hidden;
      .btnOk {
        padding: 0 10px;
        height: 36px;
        line-height: 36px;
        border-radius: 5px;
        color: #fff;
        float: left;
        margin-right: 10px;
      }
      .btn-green {
        background: #73D6CA;
      }
      .btn-blue {
        background: #3399ff;
      }
      .btn-yellow {
        background: #f7b500;
      }
      .btn-orange {
        background: #fa6400;
      }
    }
  }
}
</style>
